import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { CalibrationId, CalibrationSpeed } from 'services/equipmentSets/types';
import { createStructuredSelector } from 'reselect';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { makeSelectSpeed } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    calibrationId: CalibrationId;
}

interface ConnectedProps {
    speed: CalibrationSpeed;
}

type Props = OwnProps & ConnectedProps;

export class SpeedTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { speed } = this.props;

        return <TableCell>{speed}</TableCell>;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    speed: makeSelectSpeed()
});

export default connect(mapStateToProps)(SpeedTableCellComponent);
